const gameModes = [
  {
    name: '通常モード',
    description:
      '判明した情報を自由に使いながら、ひらがな4文字の答えを12回以内に推理します。',
    details: ['色のヒントを見て候補を整理', '初めて遊ぶときの基本設定'],
  },
  {
    name: 'ヒントモード',
    description:
      '丸や上下・左右の矢印による追加ヒントを表示し、かなの近さを確認できます。',
    details: ['設定画面でオン・オフを切り替え', 'かなの行・段の手掛かりを確認'],
  },
  {
    name: 'ハードモード',
    description:
      'これまでに開示されたヒントの条件を、次の推測でも守って挑戦します。',
    details: ['判明した文字を後続の推測で使用', '通常モードに慣れてから挑戦'],
  },
  {
    name: 'ハイコントラストモード',
    description: 'セルやキーボードの色の違いを見分けやすくする表示設定です。',
    details: ['色の見分けを補助する表示', '他のゲーム設定と組み合わせて利用'],
  },
]

export const GameDifficultyComparison: React.FC = () => {
  return (
    <section className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700 mb-12">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
        ⚙️ ゲーム設定と挑戦方法
      </h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
        本ゲームは固定のJLPTレベルや複数の単語長を選ぶ仕組みではありません。4文字の毎日問題に、設定を組み合わせて自分のペースで挑戦できます。
      </p>

      <div className="grid md:grid-cols-2 gap-4">
        {gameModes.map((mode) => (
          <article
            key={mode.name}
            className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 p-4"
          >
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
              {mode.name}
            </h3>
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-3">
              {mode.description}
            </p>
            <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1 list-disc list-inside">
              {mode.details.map((detail) => (
                <li key={detail}>{detail}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  )
}
